import MyModal from "@/components/MyModal/MyModal"
import { MODALS } from "@/constants/modals"
import { useTranslation } from "react-i18next"
import FreeMaterialReviewForm from "./FreeMaterialsReviews/FreeMaterialReviewForm"

export default function FreeMaterialsModals() {
  const { t } = useTranslation()

  return (
    <>
      <MyModal
        modalName={MODALS.freeMaterial.reviewsForm}
        title={t("freeMaterialsPage.addReview")}
      >
        <FreeMaterialReviewForm />
      </MyModal>
    </>
  )
}
